export const WorkspaceRole = {
    OWNER: 'owner',
    EDITOR: 'editor',
    REVIEWER: 'reviewer',
    VIEWER: 'viewer',
};

export const WorkspaceStatus = {
    ACTIVE: 'active',
    READ_ONLY: 'read_only',
    ARCHIVED: 'archived',
};
